import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { StatueBlockEntity } from '../../entities/BlockEntity';
import { app } from '../../app';
import { getMatch2AssetPath } from '../../util/assets';
import { Container, Sprite, randomRange } from '../../../odie';
import gsap from 'gsap';

// Statue is the id of cookie block
type StatueBlockEffectOptions = {
  entity: StatueBlockEntity;
};

export class StatueBlockEffect {
  private readonly scene: GameScene;
  private readonly entity: StatueBlockEntity;

  constructor(scene: GameScene, options: StatueBlockEffectOptions) {
    this.scene = scene;
    this.entity = options.entity;
  }

  public async animateChipBreak() {
    const particles = app.particles.create({
      textures: [getMatch2AssetPath('statue/block.statue.chip.png')],
      rate: 0,
      limit: 5,
      emitterDuration: 0,
      duration: 1.5,
      velocity: [
        { x: 0, y: -200 },
        { x: 0, y: -300 },
      ],
      scale: [
        { x: 0.7, y: 0.7 },
        { x: 1.3, y: 1.3 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [100, 200], applyRotation: true },
        { type: 'gravity', gravity: { x: 0, y: 1500 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic', directionalRotation: true },
      ],
    });

    const position = this.entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      this.entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }

  public async animateCrumbles() {
    const particles = app.particles.create({
      textures: [getMatch2AssetPath('statue/block.statue.crumb.png')],
      rate: 0,
      limit: 10,
      emitterDuration: 0,
      duration: 1.5,
      velocity: [
        { x: 0, y: -200 },
        { x: 0, y: -300 },
      ],
      scale: [
        { x: 0.7, y: 0.7 },
        { x: 1.3, y: 1.3 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [300, 400], applyRotation: true },
        { type: 'gravity', gravity: { x: 0, y: 1500 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic', directionalRotation: true },
      ],
    });

    const position = this.entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      this.entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }

  public async animateBlast() {
    const position = this.entity.c.position.mapPosition.clone();
    const blast = Sprite.from('fx.block/fx.block.explode.png');
    blast.anchorX = 0.5;
    blast.anchorY = 0.5;
    blast.scaleX = 0.2;
    blast.scaleY = 0.2;

    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      this.entity.c.block.props,
      () => blast,
      'foreground',
    );

    await gsap.to(blast, {
      scaleX: 1.6,
      scaleY: 1.6,
      duration: 0.2,
      ease: 'power1.out',
    });
    despawnOverlayEntity(this.scene, overlay);
  }
}
